export const hasExponent = (numStr: string) => {
  return /[eE]/.test(numStr)
}
